import { createSelector } from "reselect";
import { initialState } from "./reducer";

const selectCasesDetailsDomainSubmittedCases = state => state.submittedCases || initialState;

const makeSelectCasesDetails = () =>
  createSelector(
    selectCasesDetailsDomainSubmittedCases,
    substate => substate
  );

const makeSelectCardCases = () =>
  createSelector(
    selectCasesDetailsDomainSubmittedCases,
    substate => {
      return substate.cardData
    }
  );

export default makeSelectCasesDetails;
export { selectCasesDetailsDomainSubmittedCases, makeSelectCardCases };